import { render, staticRenderFns } from "./CCMLabs.vue?vue&type=template&id=4367c872"
import script from "./CCMLabs.vue?vue&type=script&lang=js"
export * from "./CCMLabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports